module.exports = __webpack_public_path__ + "media/shared/camera-success@3x-aeb3293c.png";